"use client"

import { Header } from "@/components/layout/Header"
import { Footer } from "@/components/layout/Footer"
// Laki (flying mascot) is paused for now: re-add the import and <LakiMascot /> below to bring him back
// import { LakiMascot } from "@/components/layout/LakiMascot"

export function ConditionalLayout({
  children,
}: {
  children: React.ReactNode
}) {
  // The CMS admin (/admin) has its own root layout under app/(payload)
  return (
    <>
      <Header />
      <main className="min-h-screen pt-16">{children}</main>
      <Footer />
      {/* <LakiMascot /> */}
    </>
  )
}

